// Persistance de brouillons de formulaire (anti-perte de saisie) — logique PURE.
//
// Objectif : ne plus perdre une saisie en cours quand on revient en arrière,
// qu'on change d'écran ou qu'on recharge la page. Le « storage » (interface
// localStorage : getItem/setItem/removeItem) est INJECTÉ, ce qui garde ces
// fonctions testables sans navigateur.

const PREFIX = 'ndoe:draft:';

// Clé stable et lisible ; l'id distingue par exemple une commande précise.
export const draftKey = (scope, id) => `${PREFIX}${scope}:${id === undefined || id === null || id === '' ? 'default' : id}`;

export function readDraft(storage, key) {
  if (!storage) return null;
  try {
    const raw = storage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function writeDraft(storage, key, value) {
  if (!storage) return false;
  try {
    storage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    // Quota dépassé, mode privé, JSON circulaire… : on n'échoue jamais bruyamment.
    return false;
  }
}

export function clearDraft(storage, key) {
  if (!storage) return false;
  try {
    storage.removeItem(key);
    return true;
  } catch {
    return false;
  }
}

// Ré-applique les choix sauvegardés (indexés par id_detail_livraison) sur des
// lignes FRAÎCHEMENT rechargées. Ne réintroduit jamais une ligne qui n'existe
// plus côté serveur, et n'ajoute que les champs de saisie (taken/reason/outcome).
export function mergeLinesWithDraft(lines, draft) {
  if (!Array.isArray(lines)) return lines;
  if (!draft || !Array.isArray(draft.lines)) return lines;
  const savedById = new Map(draft.lines.map((l) => [l.id_detail_livraison, l]));
  return lines.map((line) => {
    const saved = savedById.get(line.id_detail_livraison);
    if (!saved) return line;
    const patch = {};
    if (saved.taken !== undefined) patch.taken = saved.taken;
    if (saved.reason !== undefined) patch.reason = saved.reason;
    if (saved.outcome !== undefined) patch.outcome = saved.outcome;
    return { ...line, ...patch };
  });
}

// Un brouillon est « significatif » s'il contient au moins une saisie réelle
// (commentaire, encaissement, ou un choix de résultat/prise différent du défaut).
export function draftHasContent(draft) {
  if (!draft) return false;
  if (draft.comment) return true;
  if (draft.payment !== undefined && draft.payment !== '' && Number(draft.payment) > 0) return true;
  if (Array.isArray(draft.lines)) {
    return draft.lines.some((l) => l.outcome || l.taken === false || (l.reason && l.reason !== 'INDISPONIBLE_AU_DEPART'));
  }
  return false;
}
